import React, { useMemo } from 'react'
import Scroll from 'react-scroll'
import ReactScrollLink from '../General/ReactScollLink'
import PerformancePage from './index'
import AmbientPicture from '../MovieInformation/AmbientPicture'
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj'

let Element = Scroll.Element


const PerformanceSectionWithoutMovieTimes = ({itemID, activePerformance, isMobile, moviesData, theme, translation, scrollToPosition, onClosePerformancePage}) => {
    if(!moviesData[itemID]) {
        return ''
    }

    const { images } = moviesData[itemID]
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )

    const { url, id, movieTitle, timeUtc, cinema } = activePerformance

    return (
        <Element name={scrollToPosition + ' movieInformation'}>
            <div className={'movie-information'} id={'movie-performance'}>

                <div className="close-button-wrapper">
                    <ReactScrollLink to={scrollToPosition} offset={-200}>
                        <div className="close-button cursor-pointer" onClick={() => onClosePerformancePage({
                            movieTitle: movieTitle,
                            timeUtc: timeUtc
                        })}>
                              {isMobile ? (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                                    <polygon className="cls-1" points="13.73 30 14.83 28.99 2.71 15.74 30 15.74 30 14.24 2.71 14.24 14.82 1.01 13.71 0 0 14.99 13.73 30"/>
                                </svg>
                            ) : (
                                <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
                                    <polygon className="cls-1" points="25 1.06 23.94 0 12.5 11.44 1.06 0 0 1.06 11.44 12.5 0 23.94 1.06 25 12.5 13.56 23.94 25 25 23.94 13.56 12.5 25 1.06"/>
                                </svg>
                            )}
                        </div>
                    </ReactScrollLink>
                </div>

                {theme !== 'Arthouse' && <AmbientPicture isMobile={isMobile} image={backgroundsObj.ambient} />}

                <div className ={'movie-information-content-wrapper'}>
                    <div className={"movie-content performance-page-open"}>
                        <PerformancePage
                            translation={translation}
                            cinema={cinema}
                            deeplinkUrl={url}
                            showId={id}
                            scrollToPosition={itemID}
                        />
                    </div>
                </div>
            </div>
        </Element>
    )

}


export default PerformanceSectionWithoutMovieTimes